import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Option } from "components/shared/Buttons/Dropdown/Dropdown";

interface GatewayState {
  selectedGateway: Option | undefined;
}

const initialState: GatewayState = {
  selectedGateway: undefined,
};

const gatewaySlice = createSlice({
  name: "gateway",
  initialState,
  reducers: {
    selectGateway(state, action: PayloadAction<Option>) {
      state.selectedGateway = action.payload;
    },
    clearGatewaySelection(state) {
      state.selectedGateway = undefined;
    },
    updateGatewayLabel(
      state,
      action: PayloadAction<{ gatewayId: string; newLabel: string }>,
    ) {
      if (
        state.selectedGateway &&
        state.selectedGateway.id === action.payload.gatewayId
      ) {
        state.selectedGateway = {
          ...state.selectedGateway,
          label: action.payload.newLabel,
        };
      }
    },
  },
});

export const { selectGateway, clearGatewaySelection, updateGatewayLabel } =
  gatewaySlice.actions;
export default gatewaySlice.reducer;
